import $ from 'jquery';
import {useCallback, useState, useRef} from 'react';
import {fetchDepartmentSelection} from 'web/redux/actions/DepartmentActions';
import {fetchPositionSelection} from 'web/redux/actions/PositionActions';
import {fetchEmployeeList} from 'web/redux/actions/EmployeeActions';
import enumList from 'web/utils/enumList';
import {
  DataTableComponent,
  batchCheckControls,
} from 'web/components/CommonComponent';
import * as CommonEnums from '../../../../enums/CommonEnums';

const {EmployeeAreaEnums} = CommonEnums;

export const EmployeeAreaEnumMappings = new Map(
  [...Object.values(EmployeeAreaEnums)].map(({value, stringValue}) => [
    value,
    {
      label: stringValue,
      value,
    },
  ]),
);

export const useEmployee = (
  dispatch,
  baseComponent,
  showMessage,
  onBatchHandle,
  onDepartmentSelection,
  onPositionSelection,
) => {
  // const [searchPositionList, setSearchPositionList] = useState([]);
  // const [searchDepartmentList, setSearchDepartmentList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const tableRef = useRef(null);
  // const getDepartmentSelection = () => {
  //   // 取得部門選單
  //   dispatch(fetchDepartmentSelection())
  //     .then((res) => {
  //       const statusCode = res.payload.code;
  //       if (statusCode.isSuccessCode()) {
  //         const departmentSelection = res.payload.result;
  //         setSearchDepartmentList(departmentSelection);
  //         onDepartmentSelection(departmentSelection);
  //       } else {
  //         showMessage(enumList.messageModalMode.error, '', res.payload.message);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error('fetchCaseList error', err);
  //     });
  // };

  // const getPositionSelection = () => {
  //   // 取得職位選單
  //   dispatch(fetchPositionSelection())
  //     .then((res) => {
  //       const statusCode = res.payload.code;
  //       if (statusCode.isSuccessCode()) {
  //         const positionSelection = res.payload.result;
  //         setSearchPositionList(positionSelection);
  //         onPositionSelection(positionSelection);
  //       } else {
  //         showMessage(enumList.messageModalMode.error, '', res.payload.message);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error('fetchCaseList error', err);
  //     });
  // };

  const getEmployeeList = (
    employeeName,
    employeeCode,
    positionCode,
    departmentCode,
  ) => {
    if (!tableRef.current) prepareCaseTable([]);
    tableRef.current.processing(true);

    dispatch(
      fetchEmployeeList({
        employeeName,
        employeeCode,
        positionCode,
        departmentCode,
      }),
    )
      .then((res) => {
        // Get data and redraw datatable
        const statusCode = res.payload.code;
        if (statusCode.isSuccessCode()) {
          const employeeListRes = res.payload.result;
          setEmployeeList(employeeListRes);
          prepareCaseTable(employeeListRes);
          tableRef.current.processing(false);
        } else {
          showMessage(enumList.messageModalMode.error, res.payload.message);
          console.error('fetchCaseList error', res);
        }
      })
      .catch((err) => {
        showMessage(enumList.messageModalMode.error, err);
        console.error('fetchCaseList error', err);
      });
  };

  const onBatch = (alertMode = enumList.alertModalModeEnums.enable) => {
    const employeeCodes = [];
    const checkboxes = document.querySelectorAll('.item-cks-employee');
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        const employeeCode =
          employeeList[parseInt(checkbox.id.split('-')[2])].employeeCode;
        employeeCodes.push(employeeCode);
      }
    });
    // 如果沒有選擇任何資料就不處理
    if (employeeCodes.length === 0) {
      return;
    }
    onBatchHandle(alertMode, enumList.targetAction.employee, '', employeeCodes);
  };

  const prepareCaseTable = (employeeList) => {
    //     // 定義資料內容
    const dataSet = employeeList.map((employeeItem) => {
      return [
        employeeItem.employeeCode,
        employeeItem.employeeName,
        employeeItem.departmentName,
        employeeItem.positionName,
        employeeItem.email,
        employeeItem.flgStatus,
        employeeItem.conditions,
      ];
    });

    // 定義欄位屬性
    const columnConfig = [
      {
        orderable: false,
        order: null,
        title:
          '<div class="form-check"><input class="form-check-input" type="checkbox" value="" id="check-all" data-show-indeterminate="true"/><label class="form-check-label" for="check-all"></label></div>',
        data: null,
        render: function (data, type, row, meta) {
          const checkboxId = 'cks-employee-' + meta.row;
          return `
                <div class="form-check">
                    <input class="form-check-input item-cks-employee" type="checkbox" value="" id="${checkboxId}" name="cks" />
                    <label class="form-check-label" for="${checkboxId}"></label>
                </div>
            `;
        },
        width: '5%',
      },
      {
        title: '員工編號',
        className: 'dt-center',
        data: 0,
      },
      {title: '員工姓名', className: 'dt-center', data: 1},
      {title: '部門', className: 'dt-center', data: 2},
      {title: '職位', className: 'dt-center', data: 3},
      {title: 'email', className: 'dt-center', data: 4},
      {
        orderable: false,
        order: null,
        title: '啟用',
        data: 5,
        className: 'dt-center',
        render: (data, type, row, meta) => {
          const enableId = 'eab-employee-' + meta.row;
          const isChecked = data === enumList.flgStatus.active ? 'checked' : '';
          const enableButton = baseComponent.checkPermission(
            enumList.moduleEnums.employee,
            enumList.accessModeEnums.delete,
          )
            ? ''
            : 'disabled';
          return `<div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="${enableId}" ${isChecked} ${enableButton} />
                        <label class="form-check-label" for="${enableId}"></label>
                    </div>`;
        },
      },
      {
        orderable: false,
        order: null,
        title: '技能',
        data: 6,
        className: 'dt-head-center',
        render: (data, type, row, meta) => {
          const conditionFirst = data[0]
            ? ` <div class="status mx-2"> <span>${data[0].conditionName}</span> </div>`
            : '';
          const conditionSecond = data[1]
            ? ` <div class="status "> <span>${data[1].conditionName}</span> </div>`
            : '';

          return `<div class="btn-group" role="group" aria-label="">
              ${conditionFirst} ${conditionSecond}
          </div>`;
        },
      },
      {
        orderable: false,
        order: null,
        data: null,
        className: 'dt-right',
        render: (data, type, row, meta) => {
          const editId = 'edit-employee-' + meta.row;
          const updateButton = baseComponent.checkPermission(
            enumList.moduleEnums.employee,
            enumList.accessModeEnums.update,
          )
            ? `<button type="button" class="btn btn-sm btn-link" id="${editId}">
                    <svg class="btn__icon btn__icon--sm me-1" aria-hidden="true">
                        <use href="#ico-edit"></use>
                    </svg>
                    修改
                </button>`
            : '';
          return `
                <div class="btn-group" role="group" aria-label="">
                    ${updateButton}
                </div>`;
        },
      },
    ];

    // 定義排序設定
    const orderConfig = {
      idx: 1,
      dir: 'asc',
    };

    // 定義固定欄位設定
    const fixedColumnsConfig = {
      start: 1,
    };

    // 先清除datatable
    if ($.fn.DataTable.isDataTable('#datatable__elevatorList')) {
      $('#datatable__elevatorList').DataTable().destroy();
    }

    // 重新繪製datatable
    tableRef.current = DataTableComponent(
      '#datatable__elevatorList',
      dataSet,
      columnConfig,
      orderConfig,
      fixedColumnsConfig,
      true,
      true,
    );
    batchCheckControls();
  };

  return {
    // searchDepartmentList,
    // searchPositionList,
    employeeList,
    getEmployeeList,
    // getDepartmentSelection,
    // getPositionSelection,
    onBatch,
  };
};
